module.exports = __webpack_public_path__ + "img/herodaologo.6007d8c1.svg";